export default __webpack_public_path__ + "static/media/solution_62.dc747754.svg";